import React from "react";
import { withApollo } from "react-apollo";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import queryString from "query-string";

import {
  getSubcategoryListQuery,
  removeSubcategory,
  addSubCategoryViewUser,
  addSubCategoryDocUploadUser,
  getListOfSubCategoryViewUserBySubCategoryId,
  getListOfDocUploadUserBySubCategoryId,
  removeSubCategoryViewUser,
  removeSubCategoryDocUploadUser,
  updateSubCategoryForFolderView,
  updateSubCategoryForFolderUpload,
  getListOfSubcategoriesforFolderUploadQuery,
} from "../../../services/graphql/queries/category-management";

import ReactModal from "../../Common/ReactModal";
import DisplayErrors from "../../Common/DisplayErrors";

import { SET_TIMEOUT_VALUE } from "../../../constants/app-constants";

import { errorMessage } from "../../../miscellaneous/error-messages";
import { errorMsg, successMsg } from "../../../miscellaneous/react-toastify";

import BreadCrumb from "./SubCategoryBreadCrumb";
import { getUserListQuery } from "../../../services/graphql/queries/user";
import Modal from "react-awesome-modal";
import popupLogo from "../../../static/images/popup-logo.png";
import { RiFolderUploadLine } from "react-icons/ri";
import { RiFolderDownloadLine } from "react-icons/ri";
class SubcategoryList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      errors: [],
      errorsView: [],
      errorsUpload: [],
      subcategories: [],
      deleteId: "",
      reactModalVisible: false,
      requireCancel: true,
      modalMessage: "",
      addFolderViewUserModalVisible: false,
      addFolderUploadUserModalVisible: false,
      name: "",
      users: [],
      selectedRecord: null,
      isSearched: false,
      employeeId: "",
      allusers: {},
      userIds: [],
      userNames: [],
      folderViewUsers: [],
      folderUploadUsers: [],
      viewByAllUsers: true,
      uploadByAllUsers: true,
      viewUserModalVisible: false,
      requireViewUserModalCancel: true,
      removeViewUserModalMessage: "",
      deleteViewUserId: "",
      uploadUserModalVisible: false,
      requireUploadUserModalCancel: true,
      removeUploadUserModalMessage: "",
      deleteUploadUserId: "",
      activeTab: "UserView",
      showUserAddMsg: "",
      showUserAddUploadMsg: "",
      showUserViewRemoveMsg: "",
      showUserUploadRemoveMsg: "",
      updateMsg: "",
      errorAddViewUser: "",
      errorAddUploadUser: "",
    };
    this.submitModal = this.submitModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.onBreadCrumbClick = this.onBreadCrumbClick.bind(this);
    this.onCreateDocViewUsers = this.onCreateDocViewUsers.bind(this);
    this.onCreateDocUploadUsers = this.onCreateDocUploadUsers.bind(this);
    this.closeViewUserModal = this.closeViewUserModal.bind(this);
    this.submitViewUserModal = this.submitViewUserModal.bind(this);
    this.closeUploadUserModal = this.closeUploadUserModal.bind(this);
    this.submitUploadUserModal = this.submitUploadUserModal.bind(this);
  }

  handleTabChange = (tabName) => {
    this.setState({ activeTab: tabName });
  };

  onAddFolderViewUserModalVisible(subcategory) {
    this.setState(
      {
        addFolderViewUserModalVisible: !this.state
          .addFolderViewUserModalVisible,
        name: "",
        users: [],
        userIds: [],
        selectedRecord: subcategory,
        addFolderUploadUserModalVisible:false,
        viewByAllUsers: subcategory?.viewByAllUsers || false,
      },
      () => {
        if (this.state.addFolderViewUserModalVisible) {
          this.getUserList();
          this.getAllUserList();
          this.fetchFolderViewUsers(subcategory.id);
        }
      }
    );
  }

  onAddFolderUploadUserModalVisible(subcategory) {
    this.setState(
      {
        addFolderUploadUserModalVisible: !this.state
          .addFolderUploadUserModalVisible,
        name: "",
        users: [],
        userIds: [],
        selectedRecord: subcategory,
        addFolderViewUserModalVisible: false,
        uploadByAllUsers: subcategory?.uploadByAllUsers || false,
      },
      () => {
        if (this.state.addFolderUploadUserModalVisible) {
          this.getUserList();
          this.getAllUserList();
          this.fetchFolderUploadUsers(subcategory.id);
        }
      }
    );
  }

  onUpdateViewByAllUsersForFolder(selectedRecord, checkedValue) {
    this.setState({ viewByAllUsers: checkedValue });
    this.props.client
      .mutate({
        mutation: updateSubCategoryForFolderView,
        variables: {
          id: selectedRecord.id,
          name: selectedRecord.name,
          description: selectedRecord.description,
          status: selectedRecord.status,
          viewByAllUsers: checkedValue,
        },
        fetchPolicy: "no-cache",
      })
      .then((result) => {
        // successMsg("Updated successfully");
        this.setState({ updateMsg: "Updated successfully" });
        setTimeout(() => {
          this.setState({ updateMsg: "" });
        }, 3000);
        this.getListOfSubcategory();
      })
      .catch((error) => {
        console.log("~~~error: ", error);
        let message = errorMessage(error);
        errorMsg(message[0]);
        this.setState({ loading: false, errorsView: [errorMessage(error)] });
        this.timer = setTimeout(() => {
          this.setState({ errorsView: [] });
        }, SET_TIMEOUT_VALUE);
      });
  }

  onUpdateUploadByAllUsersForFolder(selectedRecord, checkedValue) {
    this.setState({ uploadByAllUsers: checkedValue });
    this.props.client
      .mutate({
        mutation: updateSubCategoryForFolderUpload,
        variables: {
          id: selectedRecord.id,
          name: selectedRecord.name,
          description: selectedRecord.description,
          status: selectedRecord.status,
          uploadByAllUsers: checkedValue,
        },
        fetchPolicy: "no-cache",
      })
      .then((result) => {
        // successMsg("Updated successfully");
        this.setState({ updateMsg: "Updated successfully" });
        setTimeout(() => {
          this.setState({ updateMsg: "" });
        }, 3000);
        this.getListOfSubcategory();
      })
      .catch((error) => {
        console.log("~~~error: ", error);
        let message = errorMessage(error);
        errorMsg(message[0]);
        this.setState({ loading: false, errorsUpload: [errorMessage(error)] });
        this.timer = setTimeout(() => {
          this.setState({ errorsUpload: [] });
        }, SET_TIMEOUT_VALUE);
      });
  }

  onCreateDocViewUsers(e) {
    e.preventDefault();
    this.props.client
      .mutate({
        mutation: addSubCategoryViewUser,
        variables: {
          categoryId: this.state.selectedRecord.categoryId.id,
          userId: this.state.userIds,
          subcategoryId: this.state.selectedRecord.id,
        },
        fetchPolicy: "no-cache",
      })
      .then((result) => {
        // successMsg("User added successfully");
        // this.onAddFolderViewUserModalVisible(null);
        this.setState({
          userNames: [],
          userIds: [],
          errorsView: [],
          showUserAddMsg: "User(s) added successfully.....",
          // users: [],
        });
        setTimeout(() => {
          this.setState({ showUserAddMsg: "" });
        }, 3000);
        this.handleTabChange("userView")
        this.fetchFolderViewUsers(this.state.selectedRecord.id);
      })
      .catch((error) => {
        console.log("~~~error: ", error);
        // this.onAddFolderViewUserModalVisible(null);
        let message = errorMessage(error);
        // errorMsg(message[0]);
        this.setState({
          loading: false,
          errorsView: [errorMessage(error)],
          userNames: [],
          userIds: [],
          activeTab: "UserView",
          errorAddViewUser: errorMessage(error)
          // users: [],
        });
        setTimeout(() => {
          this.setState({ errorAddViewUser: "" });
        }, 3000);
        this.handleTabChange("userAdd")
        this.timer = setTimeout(() => {
          this.setState({ errorsView: []});
        }, SET_TIMEOUT_VALUE);
      });
  }

  onCreateDocUploadUsers(e) {
    e.preventDefault();
    this.props.client
      .mutate({
        mutation: addSubCategoryDocUploadUser,
        variables: {
          categoryId: this.state.selectedRecord.categoryId.id,
          userId: this.state.userIds,
          subcategoryId: this.state.selectedRecord.id,
        },
        fetchPolicy: "no-cache",
      })
      .then((result) => {
        // successMsg("User added successfully");
        // this.onAddFolderUploadUserModalVisible(null);
        this.setState({
          userNames: [],
          userIds: [],
          errorsUpload: [],
          showUserAddUploadMsg: "User(s) added successfully.....",
          activeTab: "UserView",
          // users: [],
        });
        setTimeout(() => {
          this.setState({ showUserAddUploadMsg: "" });
        }, 3000);
        this.handleTabChange("userView")
        this.fetchFolderUploadUsers(this.state.selectedRecord.id);
      })
      .catch((error) => {
        console.log("~~~error: ", error);
        // this.onAddFolderUploadUserModalVisible(null);
        let message = errorMessage(error);
        // errorMsg(message[0]);
        this.setState({
          loading: false,
          errorsUpload: [errorMessage(error)],
          userNames: [],
          userIds: [],
          errorAddUploadUser: errorMessage(error)
          // users: [],
        });
        setTimeout(() => {
          this.setState({ errorAddUploadUser: "" });
        }, 3000);
        this.timer = setTimeout(() => {
          this.setState({ errorsUpload: [] });
        }, SET_TIMEOUT_VALUE);
      });
  }

  onSelectUser(e, user) {
    // this.setState({...this.state.userNames, userNames: user.name });
    if (e.target.checked) {
      this.state.userIds.push(parseInt(user.Id));
      this.state.userNames.push(user.name);
      // this.setState({...this.state.userIds, userIds: parseInt(user.Id), ...this.state.userNames, userNames: user.name});
      // this.setState({...this.state.userNames, userNames: user.name });
    } else {
      for (let i = 0; i < this.state.userIds?.length; i++) {
        if (this.state?.userIds[i] == user?.Id) {
          // this.setState({
          //   userIds: this.state.userIds.splice(i, 1),
          //   userNames: this.state.userNames.splice(i, 1)
          // });

          this.state.userIds.splice(i, 1);
          this.state.userNames.splice(i, 1);
        }
      }
    }
  }

  onCancelClicked() {
    // if(this.state.viewByAllUsers === false && this.state.folderViewUsers.length === 0) {
    //   // this.setState({ errorsView: ["Please select users or check view by all users"] });
    //   this.setState({ showUserAddMsg: "View by all users checkbox is checked since no users are selected" });
    //   this.onUpdateViewByAllUsersForFolder(
    //     this.state.selectedRecord,
    //     true
    //   )
    // }
    // else {
      this.setState(
        {
          isSearched: false,
          users: [],
          userIds: [],
          userNames: [],
          name: "",
          employeeId: "",
          errorsView: [],
          showUserAddMsg: "",
          activeTab: "userView",
          showUserViewRemoveMsg: ""
        },
        () => {
          this.onAddFolderViewUserModalVisible(null);
        }
      );
    // }
  }

  onCancelFolderUploadClicked() {
    // if(this.state.uploadByAllUsers === false && this.state.folderUploadUsers.length === 0) {
      // this.setState({ errorsUpload: ["Please select users or check upload by all users"] });
      // this.setState({ showUserAddUploadMsg: "Upload by all users checkbox is checked since no users are selected" });
      // this.onUpdateUploadByAllUsersForFolder(
      //   this.state.selectedRecord,
      //   true
      // )
    // }
    // else {
      this.setState(
        {
          isSearched: false,
          users: [],
          userIds: [],
          userNames: [],
          name: "",
          employeeId: "",
          errorsUpload: [],
          showUserAddUploadMsg: "",
          activeTab: "userView",
          showUserUploadRemoveMsg: ""
        },
        () => {
          this.onAddFolderUploadUserModalVisible(null);
        }
      );
    // }
    
  }

  compare(a, b) {
    const bandA = a.name.toUpperCase();
    const bandB = b.name.toUpperCase();
    let comparison = 0;
    if (bandA > bandB) {
      comparison = 1;
    } else if (bandA < bandB) {
      comparison = -1;
    }
    return comparison;
  }
  submitViewUserModal() {
    this.props.client
      .mutate({
        mutation: removeSubCategoryViewUser,
        variables: {
          id: this.state.deleteViewUserId,
        },
        fetchPolicy: "no-cache",
      })
      .then((result) => {
        this.setState({ viewUserModalVisible: false, addFolderViewUserModalVisible: true, showUserViewRemoveMsg: "User Removed successfully" });
        setTimeout(() => {
          this.setState({ showUserViewRemoveMsg: "" });
        }, 3000);
        // successMsg("Removed successfully");
        this.getListOfSubcategory();
        this.fetchFolderViewUsers(this.state.selectedRecord.id);
      })
      .catch((error) => {
        console.log("~~~error vieww: ", error);
        this.closeViewUserModal();
        let message = errorMessage(error);
        errorMsg(message[0]);
        this.setState({ loading: false, errorsView: [errorMessage(error)] });
        this.timer = setTimeout(() => {
          this.setState({ errorsView: [] });
        }, SET_TIMEOUT_VALUE);
      });
  }

  closeViewUserModal() {
    this.setState({ viewUserModalVisible: false, deleteViewUserId: "", errorsView: [], showUserAddMsg: "" });
  }

  submitUploadUserModal() {
    this.props.client
      .mutate({
        mutation: removeSubCategoryDocUploadUser,
        variables: {
          id: this.state.deleteUploadUserId,
        },
        fetchPolicy: "no-cache",
      })
      .then((result) => {
        this.setState({ uploadUserModalVisible: false, addFolderUploadUserModalVisible: true, showUserUploadRemoveMsg: "User Removed successfully" });
        setTimeout(() => {
          this.setState({ showUserUploadRemoveMsg: "" });
        }, 3000);
        // successMsg("Removed successfully");
        this.getListOfSubcategory();
        this.fetchFolderUploadUsers(this.state.selectedRecord.id);
      })
      .catch((error) => {
        console.log("~~~error: ", error);
        this.closeUploadUserModal();
        let message = errorMessage(error);

        errorMsg(message[0]);
        this.setState({ loading: false, errorsUpload: [errorMessage(error)] });
        this.timer = setTimeout(() => {
          this.setState({ errorsUpload: [] });
        }, SET_TIMEOUT_VALUE);
      });
  }

  closeUploadUserModal() {
    this.setState({ uploadUserModalVisible: false, deleteUploadUserId: "", errorsUpload: [], showUserAddUploadMsg: "" });
  }
  getUserList() {
    this.setState({ loading: true, users: [], isSearched: true });
    this.props.client
      .query({
        query: getUserListQuery,
        variables: {
          employeeId: this.state.employeeId ? this.state.employeeId : null,
          name: this.state.name ? this.state.name : "",
          status: 1,
        },
        fetchPolicy: "network-only",
      })
      .then((result) => {
        var users = result.data.getListOfOrgUsers;
        users = users.sort((a, b) => this.compare(a, b));

        this.initialState = {
          users: users,
        };
        this.setState({ ...this.initialState, loading: false, error: "" });
        //   this.userListUpdate(users);
      })
      .catch((error) => {
        let message = errorMessage(error);
        errorMsg(message[0]);
        this.setState({ loading: false, error: error.message });
      });
  }

  getAllUserList() {
    // this.setState({ loading: true, isSearched: true });
    this.props.client
      .query({
        query: getUserListQuery,
        variables: {
          status: 1,
        },
        fetchPolicy: "network-only",
      })
      .then((result) => {
        var allusers = result.data.getListOfOrgUsers;
        allusers.forEach((element) => {
          this.state.allusers[element.Id] = element;
        });
        this.initialState = {
          allusers: this.state.allusers,
        };
        this.setState({ ...this.initialState, loading: false, error: "" });
      })
      .catch((error) => {
        let message = errorMessage(error);
        errorMsg(message[0]);
        this.setState({ loading: false, error: error.message });
      });
  }

  fetchFolderViewUsers(referenceId) {
    this.setState({ loading: true });
    this.props.client
      .query({
        query: getListOfSubCategoryViewUserBySubCategoryId,
        variables: { referenceId: referenceId },
        fetchPolicy: "network-only",
      })
      .then((response) => {
        this.setState({
          folderViewUsers:
            response.data.getListOfSubCategoryViewUsersBySubCategoryId,
          loading: false,
        });
      })
      .catch((error) => {
        let message = errorMessage(error);
        errorMsg(message[0]);
        this.setState({ loading: false, error: error.message });
      });
  }

  fetchFolderUploadUsers(referenceId) {
    this.setState({ loading: true });
    this.props.client
      .query({
        query: getListOfDocUploadUserBySubCategoryId,
        variables: { referenceId: referenceId },
        fetchPolicy: "network-only",
      })
      .then((response) => {
        this.setState({
          folderUploadUsers:
            response.data.getListOfDocUploadUsersBySubCategoryId,
          loading: false,
        });
      })
      .catch((error) => {
        let message = errorMessage(error);
        errorMsg(message[0]);
        this.setState({ loading: false, error: error.message });
      });
  }

  submitModal() {
    this.props.client
      .mutate({
        mutation: removeSubcategory,
        variables: {
          id: this.state.deleteId,
        },
        fetchPolicy: "no-cache",
      })
      .then((result) => {
        this.setState({ reactModalVisible: false });
        successMsg("Removed successfully");
        this.getListOfSubcategory();
      })
      .catch((error) => {
        console.log("~~~error neww: ", error);
        this.closeModal();
        let message = errorMessage(error);
        errorMsg(message[0]);
        this.setState({ loading: false, errors: [errorMessage(error)] });
        this.timer = setTimeout(() => {
          this.setState({ errors: [] });
        }, SET_TIMEOUT_VALUE);
      });
  }

  closeModal() {
    this.setState({ reactModalVisible: false, deleteId: "" });
  }

  onRemoveSubcategory(id) {
    this.setState({
      reactModalVisible: true,
      modalMessage: "Are you sure, you want to delete this folder?",
      deleteId: id,
    });
  }


  // compare(a, b) {
  //     const bandA = a.userId.loginId.toUpperCase();
  //     const bandB = b.userId.loginId.toUpperCase();
  //     let comparison = 0;
  //     if (bandA > bandB) {
  //       comparison = 1;
  //     } else if (bandA < bandB) {
  //       comparison = -1;
  //     }
  //     return comparison;
  // }

  getListOfSubcategory() {
    this.setState({ loading: true });
    let subcategoryLevel =
      this.props.breadCrumbArr.length == 0 ||
      this.props.breadCrumbArr.length == 1
        ? 1
        : this.props.breadCrumbArr.length;
    this.props.client
      .query({
        query: getSubcategoryListQuery,
      //query:getListOfSubcategoriesforFolderUploadQuery,
        variables: {
          referenceId: this.props.category.id,
          categoryId: parseInt(
            queryString.parse(this.props.location.search).id
          ),
          subcategoryLevel: subcategoryLevel,
        },
        fetchPolicy: "network-only",
      })
      .then((result) => {
       var subcategories = result.data.getListOfSubcategories;
      // var subcategories = result.data.getListOfSubcategoriesforFolderUpload;
        // subcategories = subcategories.sort((a,b)=>this.compare(a,b));

        this.initialState = {
          subcategories: subcategories,
        };
        this.setState({ ...this.initialState, loading: false, error: "" });
      })
      .catch((error) => {
        let message = errorMessage(error);
        errorMsg(message[0]);
        this.setState({ loading: false, error: error.message });
      });
  }
  onRemoveViewUser(id) {
    this.setState({
      viewUserModalVisible: true,
      addFolderViewUserModalVisible: false,
      removeViewUserModalMessage:
        this.state.viewByAllUsers === false && this.state.folderViewUsers.length === 1 
        ? <div>
            <div
            style={{
              color: "red",
              fontSize: "14px",
            }}
            >There should be atleast one user in view list</div>
            "Do you still want to revoke folder view rights for this user?"
          </div> : 
        "Are you sure, you want to revoke folder view rights for this user?",
      deleteViewUserId: id,
    });
  }

  onRemoveUploadUser(id) {
    this.setState({
      uploadUserModalVisible: true,
      addFolderUploadUserModalVisible: false,
      removeUploadUserModalMessage:
        this.state.uploadByAllUsers === false && this.state.folderUploadUsers.length === 1 
          ? <div>
              <div
              style={{
                color: "red",
                fontSize: "14px",
              }}
              >There should be atleast one user in upload list</div>
              "Do you still want to revoke folder upload rights for this user?"
          </div> : 
        "Are you sure, you want to revoke folder upload rights for this user?",
      deleteUploadUserId: id,
    });
  }

  onEditSubcategory(data) {
    this.props.onEditSubcategory(data);
  }

  onUpdateSubcategory(subcategory) {
    this.props.onUpdateSubcategory(subcategory);
  }

  onBreadCrumbClick(data, index) {
    this.props.onRemoveBreadCrumb(data, index);
  }

  componentDidMount() {
    this.getListOfSubcategory();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.category !== this.props.category) {
      this.getListOfSubcategory();
    }

    if (prevState.viewByAllUsers !== this.state.viewByAllUsers && !this.state.viewByAllUsers) {
      this.setState({ activeTab: "userView" });
    }
    if (prevState.uploadByAllUsers !== this.state.uploadByAllUsers && !this.state.uploadByAllUsers) {
      this.setState({ activeTab: "userView" });
    }
  }

  render() {
    const {
      loading,
      errors,
      errorsUpload,
      errorsView,
      subcategories,
      reactModalVisible,
      requireCancel,
      modalMessage,
      addFolderViewUserModalVisible,
      addFolderUploadUserModalVisible,
      users,
      isSearched,
      name,
      folderViewUsers,
      folderUploadUsers,
      viewByAllUsers,
      uploadByAllUsers,
      viewUserModalVisible,
      uploadUserModalVisible,
      requireViewUserModalCancel,
      requireUploadUserModalCancel,
      removeViewUserModalMessage,
      removeUploadUserModalMessage,
      activeTab,
      selectedRecord,
    } = this.state;                      
    const { category, breadCrumbArr } = this.props;
    return (
      <div className="p-t-0" id="showlistDiv">
        <ReactModal
            reactModalVisible={reactModalVisible}
            submitModal={this.submitModal}
            modalMessage={modalMessage}
            requireCancel={requireCancel}
            closeModal={this.closeModal}
        />
        <ReactModal
          reactModalVisible={viewUserModalVisible}
          submitModal={this.submitViewUserModal}
          modalMessage={removeViewUserModalMessage}
          requireCancel={requireViewUserModalCancel}
          closeModal={this.closeViewUserModal}
        />
        <ReactModal
          reactModalVisible={uploadUserModalVisible}
          submitModal={this.submitUploadUserModal}
          modalMessage={removeUploadUserModalMessage}
          requireCancel={requireUploadUserModalCancel}
          closeModal={this.closeUploadUserModal}
        />
        <div className="row align-items-center">
          <div className="col-md-10">
            <h1 className="heading m-b-0">Folder List View</h1>
            <div
              className="row"
              style={{
                display: errors.length === 0 ? "none" : "block",
              }}
            >
              <div className="col-md-6">
                <div className="alert alert-success" role="alert">
                  <div className="row">
                    <span className="danger-link">
                      <DisplayErrors errors={errors} />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-2 text-right">
            <a
              href="#"
              onClick={() => this.props.toggleMode(false)}
              className="link-click "
            >
              <svg
                x="0px"
                y="0px"
                width="16px"
                height="16px"
                viewBox="0 0 16 16"
                enableBackground="new 0 0 16 16"
                xmlSpace="preserve"
              >
                <g>
                  <circle
                    fill="none"
                    stroke="#69951a"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    cx={8}
                    cy={8}
                    r="7.5"
                  />
                  <g>
                    <line
                      fill="none"
                      stroke="#69951a"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeMiterlimit={10}
                      x1="2.5"
                      y1={8}
                      x2="13.5"
                      y2={8}
                    />
                    <line
                      fill="none"
                      stroke="#69951a"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeMiterlimit={10}
                      x1={8}
                      y1="2.5"
                      x2={8}
                      y2="13.5"
                    />
                  </g>
                </g>
              </svg>
              Add
            </a>
          </div>
        </div>
        <BreadCrumb
          data={breadCrumbArr}
          onBreadCrumbClick={this.onBreadCrumbClick}
        />
        <div className="table-responsive" style={{ maxHeight: "52vh" }}>
          <table className="table table-style-1 ">
            <thead>
              <tr>
                <th scope="col" width={400}>
                  FOLDER / SUB - FOLDER NAME
                </th>
                <th scope="col" width={400}>
                  DESCRIPTION
                </th>
                <th scope="col" width={420}>
                  ACTION(s)
                </th>
              </tr>
            </thead>
            <tbody>
              {subcategories.length
                ? subcategories.map((subcategory, index) => {
                    return (
                      <tr key={index}>
                        <td
                          style={{ cursor: "pointer" }}
                          onClick={() => this.onUpdateSubcategory(subcategory)}
                        >
                          {subcategory && subcategory.name
                            ? subcategory.name
                            : ""}
                        </td>
                        <td>{subcategory.description}</td>
                        <td>
                          <a
                            href="#"
                            className="link-primary m-l-45"
                            data-toggle="tooltip"
                            data-placement="bottom"
                            title="Edit"
                          >
                            <svg
                              x="0px"
                              y="0px"
                              width="16px"
                              height="16px"
                              viewBox="0 0 16 16"
                              onClick={() =>
                                this.onEditSubcategory(subcategory)
                              }
                            >
                              <g transform="translate(0, 0)">
                                <line
                                  fill="none"
                                  stroke="#69951a"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeMiterlimit={10}
                                  x1="4.5"
                                  y1="11.5"
                                  x2="11.5"
                                  y2="11.5"
                                  data-color="color-2"
                                />
                                <line
                                  fill="none"
                                  stroke="#69951a"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeMiterlimit={10}
                                  x1="4.5"
                                  y1="8.5"
                                  x2="11.5"
                                  y2="8.5"
                                  data-color="color-2"
                                />
                                <line
                                  fill="none"
                                  stroke="#69951a"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeMiterlimit={10}
                                  x1="4.5"
                                  y1="5.5"
                                  x2="6.5"
                                  y2="5.5"
                                  data-color="color-2"
                                />
                                <polygon
                                  fill="none"
                                  stroke="#69951a"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeMiterlimit={10}
                                  points="9.5,0.5 1.5,0.5 1.5,15.5 14.5,15.5 14.5,5.5 "
                                />
                                <polyline
                                  fill="none"
                                  stroke="#69951a"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeMiterlimit={10}
                                  points="9.5,0.5 9.5,5.5 14.5,5.5 "
                                />
                              </g>
                            </svg>
                          </a>
                          {this.props.location.pathname ===
                          "/project-folder-detail" ? (
                            <a
                              href="#"
                              className="link-primary m-l-45"
                              data-toggle="tooltip"
                              data-placement="bottom"
                              title="Folder View User"
                              onClick={() =>
                                this.onAddFolderViewUserModalVisible(
                                  subcategory
                                )
                              }
                            >
                              {/* <svg
                                x="0px"
                                y="0px"
                                width="20px"
                                height="20px"
                                viewBox="0 0 16 16"
                              >
                                <g transform="translate(0, 0)">
                                  <path
                                    fill="none"
                                    stroke="#69951a"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeMiterlimit={10}
                                    d="M1.5,4.5h13v7.5h-13z"
                                  />
                                  <path
                                    fill="none"
                                    stroke="#69951a"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeMiterlimit={10}
                                    d="M2.5,3.5h3l1,1h7.5"
                                  />
                                </g>
                              </svg> */}
                              <RiFolderDownloadLine style={{width:"20px", height:"20px", color:"#69951a"}}/>
                            </a>
                          ) : null}
                          {this.props.location.pathname ===
                          "/project-folder-detail" ? (
                            <a
                              href="#"
                              className="link-primary m-l-45"
                              data-toggle="tooltip"
                              data-placement="bottom"
                              title="Folder Upload User"
                              onClick={() =>
                                this.onAddFolderUploadUserModalVisible(
                                  subcategory
                                )
                              }
                            >
                              {/* <svg
                                x="0px"
                                y="0px"
                                width="18px"
                                height="18px"
                                viewBox="0 0 16 16"
                              >
                                <g transform="translate(0, 0)">
                                  <polygon
                                    fill="none"
                                    stroke="#69951a"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    points="2,2 14,2 14,14 2,14 2,2"
                                  ></polygon>
                                  <path
                                    fill="none"
                                    stroke="#69951a"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    d="M8,12 L8,6"
                                  ></path>
                                  <polygon
                                    fill="none"
                                    stroke="#69951a"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    points="6,7 8,5 10,7"
                                  ></polygon>
                                </g>
                              </svg> */}
                              <RiFolderUploadLine style={{width:"20px", height:"20px", color:"#69951a"}}/>
                            </a>
                          ) : null}
                          <a
                            href="#"
                            className="link-delete m-l-45"
                            data-toggle="tooltip"
                            data-placement="bottom"
                            title="Delete"
                          >
                            <svg
                              x="0px"
                              y="0px"
                              width="16px"
                              height="16px"
                              viewBox="0 0 16 16"
                              onClick={() =>
                                this.onRemoveSubcategory(subcategory.id)
                              }
                            >
                              <g transform="translate(0, 0)">
                                <path
                                  fill="none"
                                  stroke="#69951a"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeMiterlimit={10}
                                  d="M2.5,6.5v7 c0,1.105,0.895,2,2,2h8c1.105,0,2-0.895,2-2v-7"
                                />
                                <line
                                  data-color="color-2"
                                  fill="none"
                                  stroke="#69951a"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeMiterlimit={10}
                                  x1="1.5"
                                  y1="3.5"
                                  x2="15.5"
                                  y2="3.5"
                                />
                                <polyline
                                  data-color="color-2"
                                  fill="none"
                                  stroke="#69951a"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeMiterlimit={10}
                                  points=" 6.5,3.5 6.5,0.5 10.5,0.5 10.5,3.5 "
                                />
                                <line
                                  fill="none"
                                  stroke="#69951a"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeMiterlimit={10}
                                  x1="8.5"
                                  y1="7.5"
                                  x2="8.5"
                                  y2="12.5"
                                />
                                <line
                                  fill="none"
                                  stroke="#69951a"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeMiterlimit={10}
                                  x1="11.5"
                                  y1="7.5"
                                  x2="11.5"
                                  y2="12.5"
                                />
                                <line
                                  fill="none"
                                  stroke="#69951a"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeMiterlimit={10}
                                  x1="5.5"
                                  y1="7.5"
                                  x2="5.5"
                                  y2="12.5"
                                />
                              </g>
                            </svg>
                          </a>
                        </td>
                      </tr>
                    );
                  })
                : null}
            </tbody>
          </table>
          {!subcategories.length && !loading ? (
            <div style={{ textAlign: "center" }}>No Data</div>
          ) : null}
        </div>

        {/* Modal for Folder View User Start */}
        <Modal
          visible={addFolderViewUserModalVisible}
          effect="fadeInDown"
          width="1100"
        >
          <div style={{ padding: "40px 40px" }}>
            <div className="modal-content" style={{ border: "none" }}>
              <div
                className="modal-header"
                style={{ display: "-webkit-box", padding: 0 }}
              >
                <div className="col-10" style={{ display: "-webkit-box" }}>
                  <figure style={{ marginRight: "20px" }}>
                    <img src={popupLogo} />
                  </figure>
                  <h1 className="heading m-l-28">Select User - Folder View [{selectedRecord?.name}]</h1>
                </div>
                <div className="col-2 text-right">
                  <a
                    href="#"
                    onClick={() => this.onCancelClicked()}
                    className="link-click"
                  >
                    <svg
                      x="0px"
                      y="0px"
                      width="16px"
                      height="16px"
                      viewBox="0 0 16 16"
                      enableBackground="new 0 0 16 16"
                      xmlSpace="preserve"
                    >
                      <g>
                        <line
                          fill="none"
                          stroke="#69951a"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeMiterlimit={10}
                          x1="3.25"
                          y1="3.25"
                          x2="12.75"
                          y2="12.75"
                        />
                        <line
                          fill="none"
                          stroke="#69951a"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeMiterlimit={10}
                          x1="12.75"
                          y1="3.25"
                          x2="3.25"
                          y2="12.75"
                        />
                      </g>
                    </svg>
                  </a>
                </div>
              </div>
              <div className="modal-body">
              {/* <div
                  className="row"
                  style={{
                    display: this.state.showUserAddMsg === "" ? "none" : "block",
                    color: "#69951a",
                    fontSize: "15px",
                    fontWeight: "bold",
                  }}
                >
                  <div className="col-md-9  col-lg-10">
                    <div className="alert alert-success" role="alert">
                      <div className="row">
                          {this.state.showUserAddMsg}
                      </div>
                    </div>
                  </div>
                </div> */}
                <div className={`success-message ${this.state.showUserAddMsg ? "show" : ""}`}>
                  {this.state.showUserAddMsg}
                </div>
                <div className={`remove-message ${this.state.showUserViewRemoveMsg ? "show" : ""}`}>
                  {this.state.showUserViewRemoveMsg}
                </div>
                <div className={`success-message ${this.state.updateMsg ? "show" : ""}`}>
                  {this.state.updateMsg}
                </div>
                <div className={`remove-message ${this.state.errorAddViewUser ? "show" : ""}`}>
                  {this.state.errorAddViewUser}
                </div>
                <div className="row">
                  <div className="col-md-5 col-lg-6">

                    {/* <div
                      className="row"
                      style={{
                        display: errorsView.length === 0 ? "none" : "block",
                      }}
                    >
                      <div className="col-md-10">
                        <div className="alert alert-success" role="alert">
                          <div className="row">
                            <span className="danger-link">
                              <DisplayErrors errors={errorsView} />
                            </span>
                          </div>
                        </div>
                      </div>
                    </div> */}
                    {/* <div
                      style={{
                        color: "red",
                        fontSize: "14px",
                        visibility: this.state.viewByAllUsers === false && this.state.folderViewUsers.length === 0 
                                    ||  this.state.viewByAllUsers === false && this.state.folderViewUsers.length === 0  && this.state.userNames.length === 0
                                    ? "visible" : "hidden",
                      }}
                    >
                      Please select users or check VIEW BY ALL USERS
                    </div> */}
                    <div className="form-group">
                      <label>VIEW BY ALL USERS</label>
                      <input
                        type="checkbox"
                        className="userCheckbox m-4"
                        checked={viewByAllUsers}
                        onChange={(e) =>
                          this.onUpdateViewByAllUsersForFolder(
                            selectedRecord,
                            e.target.checked
                          )
                        }
                      />
                    </div>
                  </div>
                </div>
                {!viewByAllUsers && (
                  <div className="tabs">
                    <ul className="nav nav-pills">
                      <li className="nav-item">
                        <a
                          className={`nav-link ${
                            activeTab === "userView" ? "active" : ""
                          }`}
                          id="user-view-tab"
                          data-toggle="pill"
                          href="#user-view"
                          role="tab"
                          aria-controls="user-view"
                          aria-selected={
                            activeTab === "userView" ? "true" : "false"
                          }
                          onClick={() => this.handleTabChange("userView")}
                        >
                          <span>User View</span>
                        </a>
                      </li>
                      <li className="nav-item">
                        <a
                          className={`nav-link ${
                            activeTab === "userAdd" ? "active" : ""
                          }`}
                          id="user-add-tab"
                          data-toggle="pill"
                          href="#user-add"
                          role="tab"
                          aria-controls="user-add"
                          aria-selected={
                            activeTab === "userAdd" ? "true" : "false"
                          }
                          onClick={() => this.handleTabChange("userAdd")}
                        >
                          <span>User Add</span>
                        </a>
                      </li>
                    </ul>
                    <div className="tab-content">
                      {activeTab === "userView" && (
                        <div className="tab-pane active">
                          {folderViewUsers.length ? (
                            <div className="row">
                              <div className="col-md-12">
                                <h4
                                  style={{
                                    color: "#0087d5",
                                    fontWeight: "bold",
                                  }}
                                >
                                  Users (Folder-View)
                                </h4>
                                <div
                                  className="table-responsive"
                                  style={{ height: "35vh" }}
                                >
                                  <table className="table table-style-1 m-t-15">
                                    <thead>
                                      <tr>
                                        <th scope="col" width={420}>
                                          NAME
                                        </th>
                                        <th scope="col" width={400}>
                                          LOGIN ID
                                        </th>
                                        <th scope="col" width={200}>
                                          ACTION(s)
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {folderViewUsers.map((user, index) => (
                                        <tr key={index}>
                                          <td>{user.userDetail?.name}</td>
                                          <td>{user.userId?.loginId}</td>
                                          <td>
                                            <a
                                              href="#"
                                              className="link-delete m-l-35"
                                              data-toggle="tooltip"
                                              data-placement="bottom"
                                              title="Delete"
                                            >
                                              <svg
                                                x="0px"
                                                y="0px"
                                                width="16px"
                                                height="16px"
                                                viewBox="0 0 16 16"
                                                onClick={() =>
                                                  this.onRemoveViewUser(user.id)
                                                }
                                              >
                                                <g transform="translate(0, 0)">
                                                  <path
                                                    fill="none"
                                                    stroke="#69951a"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeMiterlimit={10}
                                                    d="M2.5,6.5v7 c0,1.105,0.895,2,2,2h8c1.105,0,2-0.895,2-2v-7"
                                                  />
                                                  <line
                                                    data-color="color-2"
                                                    fill="none"
                                                    stroke="#69951a"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeMiterlimit={10}
                                                    x1="1.5"
                                                    y1="3.5"
                                                    x2="15.5"
                                                    y2="3.5"
                                                  />
                                                  <polyline
                                                    data-color="color-2"
                                                    fill="none"
                                                    stroke="#69951a"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeMiterlimit={10}
                                                    points="6.5,3.5 6.5,0.5 10.5,0.5 10.5,3.5"
                                                  />
                                                  <line
                                                    fill="none"
                                                    stroke="#69951a"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeMiterlimit={10}
                                                    x1="8.5"
                                                    y1="7.5"
                                                    x2="8.5"
                                                    y2="12.5"
                                                  />
                                                  <line
                                                    fill="none"
                                                    stroke="#69951a"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeMiterlimit={10}
                                                    x1="11.5"
                                                    y1="7.5"
                                                    x2="11.5"
                                                    y2="12.5"
                                                  />
                                                  <line
                                                    fill="none"
                                                    stroke="#69951a"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeMiterlimit={10}
                                                    x1="5.5"
                                                    y1="7.5"
                                                    x2="5.5"
                                                    y2="12.5"
                                                  />
                                                </g>
                                              </svg>
                                            </a>
                                          </td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          ) : null}

                          {!folderViewUsers.length && !loading && (
                            <div style={{ textAlign: "center" }}>No Data</div>
                          )}
                        </div>
                      )}
                      
                      {activeTab === "userAdd" && (
                        <div className="tab-pane active">
                          <div className="row">
                            <div className="col-6">
                              <div className="form-group">
                                <label>NAME</label>
                                <div className="ui-widget">
                                  <input
                                    id="name"
                                    className="form-control autocomplete"
                                    placeholder="Please Enter Employee Name"
                                    value={name}
                                    onChange={(e) =>
                                      this.setState({ name: e.target.value })
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="col-2">
                              <div className="form-group">
                                <button
                                  type="button"
                                  className="btn btn-danger popup-button-danger m-t-28"
                                  onClick={() => this.getUserList()}
                                >
                                  Go
                                </button>
                              </div>
                            </div>
                          </div>
                          {users.length ? (
                            <div className="row">
                              <div className="col-md-12">
                                <form onSubmit={this.onCreateDocViewUsers}>
                                  <div
                                    className="table-responsive"
                                    style={{ height: "30vh" }}
                                  >
                                    <table className="table table-style-1 m-t-15">
                                      <thead>
                                        <tr>
                                          <th scope="col" width={420}>
                                            NAME
                                          </th>
                                          <th scope="col" width={400}>
                                            EMAIL ID
                                          </th>
                                          <th scope="col" width={200}>
                                            ACTION(s)
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {users.length
                                          ? users.map((user, index) => {
                                              return (
                                                <tr key={index}>
                                                  <td>{user.name}</td>
                                                  <td>{user.emailId}</td>
                                                  <td>
                                                    <input
                                                      type="checkbox"
                                                      id={
                                                        user.Id +
                                                        "_" +
                                                        user.name
                                                      }
                                                      className="userCheckbox"
                                                      onChange={(e) =>
                                                        this.onSelectUser(
                                                          e,
                                                          user
                                                        )
                                                      }
                                                    />
                                                  </td>
                                                </tr>
                                              );
                                            })
                                          : null}
                                      </tbody>
                                    </table>
                                  </div>
                                  <div className="text-right m-t-30">
                                    <button
                                      type="submit"
                                      className="btn btn-danger popup-button-danger"
                                    >
                                      Submit
                                    </button>
                                  </div>
                                </form>
                              </div>
                            </div>
                          ) : null}
                          {!users.length && isSearched && !loading ? (
                            <div style={{ textAlign: "center" }}>No Data</div>
                          ) : null}
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </Modal>
        {/* Modal for Folder View User End*/}

        {/* Modal for Folder Upload User Start*/}
        <Modal
          visible={addFolderUploadUserModalVisible}
          effect="fadeInDown"
          width="1100"
        >
          <div style={{ padding: "40px 40px" }}>
            <div className="modal-content" style={{ border: "none" }}>
              <div
                className="modal-header"
                style={{ display: "-webkit-box", padding: 0 }}
              >
                <div className="col-10" style={{ display: "-webkit-box" }}>
                  <figure style={{ marginRight: "20px" }}>
                    <img src={popupLogo} />
                  </figure>
                  <h1 className="heading m-l-28">
                    Select User - Folder Upload [{selectedRecord?.name}]
                  </h1>
                </div>
                <div className="col-2 text-right">
                  <a
                    href="#"
                    onClick={() => this.onCancelFolderUploadClicked()}
                    className="link-click"
                  >
                    <svg
                      x="0px"
                      y="0px"
                      width="16px"
                      height="16px"
                      viewBox="0 0 16 16"
                      enableBackground="new 0 0 16 16"
                      xmlSpace="preserve"
                    >
                      <g>
                        <line
                          fill="none"
                          stroke="#69951a"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeMiterlimit={10}
                          x1="3.25"
                          y1="3.25"
                          x2="12.75"
                          y2="12.75"
                        />
                        <line
                          fill="none"
                          stroke="#69951a"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeMiterlimit={10}
                          x1="12.75"
                          y1="3.25"
                          x2="3.25"
                          y2="12.75"
                        />
                      </g>
                    </svg>
                  </a>
                </div>
              </div>
              <div className="modal-body">

                {/* <div
                  className="row"
                  style={{
                    display: this.state.showUserAddUploadMsg === "" ? "none" : "block",
                    color: "#69951a",
                    fontSize: "15px",
                    fontWeight: "bold",
                  }}
                >
                  <div className="col-md-9  col-lg-10">
                    <div className="alert alert-success" role="alert">
                      <div className="row">
                          {this.state.showUserAddUploadMsg}
                      </div>
                    </div>
                  </div>
                </div> */}
                <div className={`success-message ${this.state.showUserAddUploadMsg ? "show" : ""}`}>
                  {this.state.showUserAddUploadMsg}
                </div>
                <div className={`remove-message ${this.state.showUserUploadRemoveMsg ? "show" : ""}`}>
                  {this.state.showUserUploadRemoveMsg}
                </div>
                <div className={`success-message ${this.state.updateMsg ? "show" : ""}`}>
                  {this.state.updateMsg}
                </div>
                <div className={`remove-message ${this.state.errorAddUploadUser ? "show" : ""}`}>
                  {this.state.errorAddUploadUser}
                </div>
                <div className="row">
                  <div className="col-md-5 col-lg-6">

                  {/* <div
                    className="row"
                    style={{
                      display: errorsUpload.length === 0 ? "none" : "block",
                    }}
                  >
                    <div className="col-md-10">
                      <div className="alert alert-success" role="alert">
                        <div className="row">
                          <span className="danger-link">
                            <DisplayErrors errors={errorsUpload} />
                          </span>
                        </div>
                      </div>
                    </div>
                  </div> */}

                    {/* <div
                      style={{
                        color: "red",
                        fontSize: "14px",
                        visibility: this.state.uploadByAllUsers === false && this.state.folderUploadUsers.length === 0 ? "visible" : "hidden",
                      }}
                    >
                      Please select users or check UPLOAD BY ALL USERS
                    </div> */}
                    <div className="form-group">
                      <label>UPLOAD BY ALL USERS</label>
                      <input
                        type="checkbox"
                        className="userCheckbox m-4"
                        checked={uploadByAllUsers}
                        // onChange={(e) =>
                        //   this.setState({ uploadByAllUsers: e.target.checked })
                        // }
                        onChange={(e) =>
                          this.onUpdateUploadByAllUsersForFolder(
                            selectedRecord,
                            e.target.checked
                          )
                        }
                      />
                    </div>
                  </div>
                </div>
                {!uploadByAllUsers && (
                  <div className="tabs">
                    <ul className="nav nav-pills">
                      <li className="nav-item">
                        <a
                          className={`nav-link ${
                            activeTab === "userView" ? "active" : ""
                          }`}
                          id="user-view-tab"
                          data-toggle="pill"
                          href="#user-view"
                          role="tab"
                          aria-controls="user-view"
                          aria-selected={
                            activeTab === "userView" ? "true" : "false"
                          }
                          onClick={() => this.handleTabChange("userView")}
                        >
                          <span>User Upload</span>
                        </a>
                      </li>
                      <li className="nav-item">
                        <a
                          className={`nav-link ${
                            activeTab === "userAdd" ? "active" : ""
                          }`}
                          id="user-add-tab"
                          data-toggle="pill"
                          href="#user-add"
                          role="tab"
                          aria-controls="user-add"
                          aria-selected={
                            activeTab === "userAdd" ? "true" : "false"
                          }
                          onClick={() => this.handleTabChange("userAdd")}
                        >
                          <span>User Add</span>
                        </a>
                      </li>
                    </ul>
                    <div className="tab-content">
                      {activeTab === "userView" && (
                        <div className="tab-pane active">
                          {folderUploadUsers.length ? (
                            <div className="row">
                              <div className="col-md-12">
                                <h4
                                  style={{
                                    color: "#0087d5",
                                    fontWeight: "bold",
                                  }}
                                >
                                  Users (Folder-Upload)
                                </h4>
                                <div
                                  className="table-responsive"
                                  style={{ height: "35vh" }}
                                >
                                  <table className="table table-style-1 m-t-15">
                                    <thead>
                                      <tr>
                                        <th scope="col" width={420}>
                                          NAME
                                        </th>
                                        <th scope="col" width={400}>
                                          LOGIN ID
                                        </th>
                                        <th scope="col" width={200}>
                                          ACTION(s)
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {folderUploadUsers.map((user, index) => (
                                        <tr key={index}>
                                          <td>{user.userDetail?.name}</td>
                                          <td>{user.userId?.loginId}</td>
                                          <td>
                                            <a
                                              href="#"
                                              className="link-delete m-l-35"
                                              data-toggle="tooltip"
                                              data-placement="bottom"
                                              title="Delete"
                                            >
                                              <svg
                                                x="0px"
                                                y="0px"
                                                width="16px"
                                                height="16px"
                                                viewBox="0 0 16 16"
                                                onClick={() =>
                                                  this.onRemoveUploadUser(
                                                    user.id
                                                  )
                                                }
                                              >
                                                <g transform="translate(0, 0)">
                                                  <path
                                                    fill="none"
                                                    stroke="#69951a"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeMiterlimit={10}
                                                    d="M2.5,6.5v7 c0,1.105,0.895,2,2,2h8c1.105,0,2-0.895,2-2v-7"
                                                  />
                                                  <line
                                                    data-color="color-2"
                                                    fill="none"
                                                    stroke="#69951a"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeMiterlimit={10}
                                                    x1="1.5"
                                                    y1="3.5"
                                                    x2="15.5"
                                                    y2="3.5"
                                                  />
                                                  <polyline
                                                    data-color="color-2"
                                                    fill="none"
                                                    stroke="#69951a"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeMiterlimit={10}
                                                    points="6.5,3.5 6.5,0.5 10.5,0.5 10.5,3.5"
                                                  />
                                                  <line
                                                    fill="none"
                                                    stroke="#69951a"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeMiterlimit={10}
                                                    x1="8.5"
                                                    y1="7.5"
                                                    x2="8.5"
                                                    y2="12.5"
                                                  />
                                                  <line
                                                    fill="none"
                                                    stroke="#69951a"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeMiterlimit={10}
                                                    x1="11.5"
                                                    y1="7.5"
                                                    x2="11.5"
                                                    y2="12.5"
                                                  />
                                                  <line
                                                    fill="none"
                                                    stroke="#69951a"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeMiterlimit={10}
                                                    x1="5.5"
                                                    y1="7.5"
                                                    x2="5.5"
                                                    y2="12.5"
                                                  />
                                                </g>
                                              </svg>
                                            </a>
                                          </td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          ) : null}

                          {!folderUploadUsers.length && !loading && (
                            <div style={{ textAlign: "center" }}>No Data</div>
                          )}
                        </div>
                      )}
                      {activeTab === "userAdd" && (
                        <div className="tab-pane active">
                          <div className="row">
                            <div className="col-6">
                              <div className="form-group">
                                <label>NAME</label>
                                <div className="ui-widget">
                                  <input
                                    id="name"
                                    className="form-control autocomplete"
                                    placeholder="Please Enter Employee Name"
                                    value={name}
                                    onChange={(e) =>
                                      this.setState({ name: e.target.value })
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="col-2">
                              <div className="form-group">
                                <button
                                  type="button"
                                  className="btn btn-danger popup-button-danger m-t-28"
                                  onClick={() => this.getUserList()}
                                >
                                  Go
                                </button>
                              </div>
                            </div>
                          </div>
                          {users.length ? (
                            <div className="row">
                              <div className="col-md-12">
                                <form onSubmit={this.onCreateDocUploadUsers}>
                                  <div
                                    className="table-responsive"
                                    style={{ height: "30vh" }}
                                  >
                                    <table className="table table-style-1 m-t-15">
                                      <thead>
                                        <tr>
                                          <th scope="col" width={420}>
                                            NAME
                                          </th>
                                          <th scope="col" width={400}>
                                            EMAIL ID
                                          </th>
                                          <th scope="col" width={200}>
                                            ACTION(s)
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {users.length
                                          ? users.map((user, index) => {
                                              return (
                                                <tr key={index}>
                                                  <td>{user.name}</td>
                                                  <td>{user.emailId}</td>
                                                  <td>
                                                    <input
                                                      type="checkbox"
                                                      id={
                                                        user.Id +
                                                        "_" +
                                                        user.name
                                                      }
                                                      className="userCheckbox"
                                                      onChange={(e) =>
                                                        this.onSelectUser(
                                                          e,
                                                          user
                                                        )
                                                      }
                                                    />
                                                  </td>
                                                </tr>
                                              );
                                            })
                                          : null}
                                      </tbody>
                                    </table>
                                  </div>
                                  <div className="text-right m-t-30">
                                    <button
                                      type="submit"
                                      className="btn btn-danger popup-button-danger"
                                    >
                                      Submit
                                    </button>
                                  </div>
                                </form>
                              </div>
                            </div>
                          ) : null}
                          {!users.length && isSearched && !loading ? (
                            <div style={{ textAlign: "center" }}>No Data</div>
                          ) : null}
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </Modal>
        {/* Modal for Folder Upload User End*/}
      </div>
    );
  }
}

export default withRouter(connect()(withApollo(SubcategoryList)));
